import { createContext, useContext, type ReactNode } from "react";

export interface AppConfig {
  environment: "development" | "staging" | "production";
  convertkitFormId: number;
  /** Where the browser reaches the API; the server has its own (env.server). */
  apiOrigin: string;
}

const ConfigContext = createContext<AppConfig | null>(null);

export function ConfigProvider({
  value,
  children,
}: {
  value: AppConfig;
  children: ReactNode;
}) {
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
}

export function useAppConfig(): AppConfig {
  const config = useContext(ConfigContext);
  if (!config) throw new Error("useAppConfig used outside ConfigProvider");
  return config;
}
